import React, { useEffect, useState } from 'react';
import { Checkbox, Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import CustomButton from '../components/Button';
import styles from './approvalModal.module.scss';

interface ApprovalModalProps {
  visible: boolean;
  onCancel: () => void;
  onConfirm: (changeSubentries: boolean) => void;
  loading?: boolean;
  hasSubentries?: boolean;
  variant?: 'internal' | 'external';
}

const ApprovalModal: React.FC<ApprovalModalProps> = ({
  visible,
  onCancel,
  onConfirm,
  loading = false,
  hasSubentries = false,
  variant = 'internal',
}) => {
  const [changeSubentries, setChangeSubentries] = useState(false);

  useEffect(() => {
    if (visible) setChangeSubentries(false);
  }, [visible]);

  return (
    <Modal
      centered
      title={
        <div className={styles.modalHeader}>
          <span className={styles.modalTitle}>Approve Status</span>
          <CloseOutlined onClick={onCancel} className={styles.closeIcon} />
        </div>
      }
      open={visible}
      onCancel={onCancel}
      footer={null}
      className={`${styles.approvalModal} ${variant === 'external' ? styles.approvalModalExternal : ''}`}
      width={600}
    >
      <div className={styles.modalContent}>
        <div className={styles.content}>
          <p className={styles.mainTextLead}>
            All comments will be resolved for approved status.
          </p>
          <p className={styles.mainTextQuestion}>Would you like to continue with approval?</p>

          {hasSubentries && (
            <div className={styles.subentriesBlock}>
              <Checkbox checked={changeSubentries} onChange={(e) => setChangeSubentries(e.target.checked)}>
                Change status of sub-items as well
              </Checkbox>
              <p className={styles.hintText}>
                If this option is checked, the status of all files, folders, versions and sub-items under the
                selected item will also be changed to approved status.
              </p>
            </div>
          )}
        </div>

        <div className={styles.actionButtons}>
          <CustomButton onClick={onCancel} className={styles.cancelButton} type="default">
            Cancel
          </CustomButton>
          <CustomButton
            onClick={() => onConfirm(changeSubentries)}
            loading={loading}
            className={styles.confirmButton}
            type="primary"
          >
            Continue
          </CustomButton>
        </div>
      </div>
    </Modal>
  );
};

export default ApprovalModal;
